class PieceStyleItWith extends HTMLElement {
  connectedCallback() {
    this.groups = [...this.querySelectorAll('[data-piece-siw-group]')];
    this.activateGroup();
    this.bindActiveGroup();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.onPreviousClick);
    this.nextButton?.removeEventListener('click', this.onNextClick);

    if (this.grid && this.onScroll) {
      this.grid.removeEventListener('scroll', this.onScroll);
    }
    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }
  }

  activateGroup() {
    const lookHandle = new URLSearchParams(window.location.search).get('stl_look');
    const contextualGroup = this.groups.find(
      (group) => group.dataset.pieceSiwGroup === lookHandle
    );
    const defaultGroup = this.groups.find(
      (group) => group.dataset.pieceSiwGroup === 'all'
    );

    this.activeGroup = contextualGroup || defaultGroup;

    this.groups.forEach((group) => {
      const isActive = group === this.activeGroup;
      group.hidden = !isActive;
      group.setAttribute('aria-hidden', String(!isActive));
    });
  }

  bindActiveGroup() {
    if (!this.activeGroup) return;

    this.grid = this.activeGroup.querySelector('[data-piece-siw-carousel]');
    this.prevButton = this.activeGroup.querySelector('[data-piece-siw-prev]');
    this.nextButton = this.activeGroup.querySelector('[data-piece-siw-next]');
    this.cards = [...this.activeGroup.querySelectorAll('.piece-siw__card')];

    this.onPreviousClick = () => this.scrollTrack(-1);
    this.onNextClick = () => this.scrollTrack(1);
    this.prevButton?.addEventListener('click', this.onPreviousClick);
    this.nextButton?.addEventListener('click', this.onNextClick);

    if (this.grid) {
      this.onScroll = () => this.updateArrows();
      this.grid.addEventListener('scroll', this.onScroll);
      this.onResize = () => this.updateArrows();
      window.addEventListener('resize', this.onResize);
      this.updateArrows();
    }
  }

  getCardOffsets() {
    return this.cards.map((card) => card.offsetLeft);
  }

  getActiveIndex() {
    if (!this.grid || this.cards.length === 0) return 0;

    const current = this.grid.scrollLeft;
    let activeIndex = 0;

    this.getCardOffsets().forEach((offset, index) => {
      if (offset <= current + 8) {
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  updateArrows() {
    if (!this.grid || !this.prevButton || !this.nextButton) return;

    const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
    this.prevButton.disabled = this.grid.scrollLeft <= 4;
    this.nextButton.disabled = this.grid.scrollLeft >= maxScroll - 4;
  }

  scrollTrack(direction) {
    if (!this.grid || this.cards.length === 0) return;

    const offsets = this.getCardOffsets();
    const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
    const activeIndex = this.getActiveIndex();
    const targetIndex =
      direction > 0
        ? Math.min(activeIndex + 1, offsets.length - 1)
        : Math.max(activeIndex - 1, 0);
    const target = Math.max(0, Math.min(offsets[targetIndex], maxScroll));

    this.grid.scrollTo({ left: target, behavior: 'smooth' });
  }
}

if (!customElements.get('piece-style-it-with')) {
  customElements.define('piece-style-it-with', PieceStyleItWith);
}
